import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppointmentInventory } from 'src/app/core/models/appointment-inventory.model';
import { Appointment } from 'src/app/core/models/appointment.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';

@Component({
	selector: 'app-inventory-active-tab',
	templateUrl: './inventory-active-tab.component.html',
	styleUrls: ['./inventory-active-tab.component.scss'],
})
export class InventoryActiveTabComponent {

	activeItems: AppointmentInventory[];
	activeAppointmentSub: any;
	expandedItems = [] as number[];

	constructor(
		private activatedRoute: ActivatedRoute,
		private appointmentService: AppointmentService
	) { }

	async ionViewWillEnter() {
		const id = this.activatedRoute.snapshot.parent.parent.params?.id;
		const appointment = await this.appointmentService.getLocalAppointment(id);
		this.setActiveItems(appointment);
		this.updateActiveItemsAfterSync();
	}

	ionViewWillLeave() {
		this.activeAppointmentSub.unsubscribe();
	}

	setActiveItems(appointment: Appointment) {
		this.activeItems = appointment.inventory.filter(i => i.statusId == 1 && i.originalStatusId == 1);
	}

	updateActiveItemsAfterSync() {
		this.activeAppointmentSub = this.appointmentService.activeAppointment$
			.subscribe(newAppointment => {
				if (newAppointment) {
					this.setActiveItems(newAppointment);
				}
			});
	}

	onClickToggleSection(sectionIndex: number) {
		const foundIndex = this.expandedItems.findIndex(index => index === sectionIndex);
		if (foundIndex === -1) {
			this.expandedItems.push(sectionIndex);
			return;
		}

		this.expandedItems.splice(foundIndex, 1);
	}

	isVisible(sectionIndex: number) {
		return (this.expandedItems.findIndex(index => index === sectionIndex) > -1);
	}
}
